export default class Designations {
  constructor() {
    this.maritalStatus = true;
    this.spousalConsent = true;
  }

  loadData(payload) {
    if (payload.Personal_Info) {
      this.maritalStatus = payload.Personal_Info.Marital_Status;
      this.spousalConsent = payload.Personal_Info.Spousal_Consent;
    }
  }
}
